import React from 'react'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'

// For the affirmPrimary prompt: a previously-verified email whose confirmation
// has gone stale. No code round trip — "Yes, it is" affirms directly.
const EmailVerificationAffirmPrimaryOffer = (props) => {
  const {
    email, onAffirm, onDifferentEmail, onRemindLater,
    remindLoading, confirmLoading, confirmedMessage, errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration checkColor={confirmedMessage ? '#30C99C' : undefined} />
      <div className='emailVerificationFlow-title'>Is this still your email?</div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Email</div>
        <div className='emailVerificationFlow-emailDisplay'>{email}</div>
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      {confirmedMessage && (
        <div className='emailVerificationFlow-codeEntry-verifiedMessage'>{confirmedMessage}</div>
      )}
      <button
        type='button'
        className={`btn btn--blue btn--large${(confirmLoading || confirmedMessage) ? ' btn--disabled' : ''}`}
        onClick={onAffirm}
        disabled={confirmLoading || !!confirmedMessage}
      >
        Yes, it is
      </button>
      {!confirmedMessage && (
        <div className='emailVerificationFlow-primaryOffer-links'>
          <button type='button' className='emailVerificationFlow-linkBtn' onClick={onDifferentEmail}>
            I use a different email now
          </button>
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onRemindLater}
            disabled={remindLoading}
          >
            Remind me later
          </button>
        </div>
      )}
    </div>
  )
}

export default EmailVerificationAffirmPrimaryOffer
